import React from "react";
import "../../../styles/utils/button/PaginationButtons.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

const PaginationButtons = ({ onPrev, onNext, currentPage, totalPages }) => {
  const { t } = useAppTranslation("components/utils/pagination");
  const hasPages = totalPages > 0;
  const isFirstPage = !hasPages || currentPage <= 1;
  const isLastPage = !hasPages || currentPage >= totalPages;

  return (
    <div className="button-container">
      <button onClick={onPrev} disabled={isFirstPage}>
        {t("prev")}
      </button>
      <button onClick={onNext} disabled={isLastPage}>
        {t("next")}
      </button>
    </div>
  );
};

export default PaginationButtons;
